// ── Management Query Keys ──────────────────────────────────────────────────
// Format: ['management', sub-feature, operation, ...params]

export const managementKeys = {
  all: ['management'],
  roles: () => ['management', 'roles'],
  roleList: (params) => ['management', 'roles', 'list', params],
  roleDetail: (id) => ['management', 'roles', 'detail', id],
  menus: () => ['management', 'menus'],
  users: () => ['management', 'users'],
  userList: (params) => ['management', 'users', 'list', params],
  userDetail: (id) => ['management', 'users', 'detail', id],
  companies: () => ['management', 'companies'],
  companyList: (params) => ['management', 'companies', 'list', params],
  companyDetail: (id) => ['management', 'companies', 'detail', id],
  companyOrganizations: (companyId, params) => [
    'management',
    'companies',
    companyId,
    'organizations',
    params,
  ],
  dorSettings: (companyId) => [
    'management',
    'companies',
    companyId,
    'dor-settings',
  ],
  companyClaimTabSettings: (companyId) => [
    'management',
    'companies',
    companyId,
    'claim-tab-settings',
  ],
  // MUTATION key (not a query key): lets every board instance — including one
  // mounted after another started the save — see this company's PUT in flight.
  companyClaimTabSettingsSave: (companyId) => [
    'management',
    'companies',
    companyId,
    'claim-tab-settings',
    'save',
  ],
  // MUTATION key (not a query key) for the display-mode upsert
  // (`claim-detail-setting`): a remounted display card sees the earlier
  // card's upsert in flight and sends no overlapping one (BE 409).
  companyClaimDetailSettingSave: (companyId) => [
    'management',
    'companies',
    companyId,
    'claim-detail-setting',
    'save',
  ],
  // Claim field master list (SA-2096). Global, not company-scoped.
  claimFields: () => ['management', 'claim-fields'],
  companyClaimTypes: (companyId) => [
    'management',
    'companies',
    companyId,
    'claim-types',
  ],
  summaryTypes: () => ['management', 'summary-types'],
  summaryTypeList: (params) => ['management', 'summary-types', 'list', params],
  // Claim Automation (SA-1842). Masters are not company-scoped.
  automationMasters: () => [
    'management',
    'automation-claim-settings',
    'masters',
  ],
  companyAutomationSettings: (companyId) => [
    'management',
    'companies',
    companyId,
    'automation-claim-settings',
  ],
  companyTpaPartners: (companyId, params) => [
    'management',
    'companies',
    companyId,
    'tpa-partners',
    params,
  ],
  // Disease flags (SA-2095) — one list holds every flag type.
  companyDiseaseFlags: (companyId) => [
    'management',
    'companies',
    companyId,
    'disease-flags',
  ],
  // Global unwritten rules (SA-2158). Superadmin-wide, not company-scoped.
  unwrittenRules: () => ['management', 'unwritten-rules'],
  unwrittenRuleList: (params) => [
    'management',
    'unwritten-rules',
    'list',
    params,
  ],
  unwrittenRuleDetail: (id) => ['management', 'unwritten-rules', 'detail', id],
  unwrittenCategories: (params) => [
    'management',
    'unwritten-categories',
    params,
  ],
};

export const managementRefetchInterval = {
  USER_LIST: 5 * 60 * 1000, // 5 min — keeps `last_active_at` current
};

export const managementStaleTime = {
  LIST: 5 * 60 * 1000, // 5 min — paginated role table
  DETAIL: 5 * 60 * 1000, // 5 min — single role detail
  MENUS: 10 * 60 * 1000, // 10 min — menu list changes rarely
  MASTERS: 30 * 60 * 1000, // 30 min — static master data shared by every company
};
